import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Row} from "reactstrap";
import {Field, reduxForm} from "redux-form";
import {CheckBoxField, InputField} from "../../../../../validation/ReduxFormInput";
import {handleSubmitBio} from "../../../actions/application";

class BioForm extends Component {
    render() {
        const {handleSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <Field name="bio" component={InputField}
                               placeholder="My name's John Corotis and I'm a full time employee at Mindbody here in San Luis Obispo. I recently moved to town from the rainy (but beautiful) Seattle, WA. I completed my undergrad at UW where I studied Psychology and Underwater Basket Weaving. I'm an expert at holding my breath, knitting, and analyzing strangers. I'm planning on staying in SLO for the next few years while I save up enough money to buy a sailboat and figure out what to do with my life."
                               rows={10}
                               type="textarea"/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Field name="polyrents_tos"
                               label="I agree to let PolyRents share this information with landlords whose properties I'm applying to or showing interest in. I also understand that my rental references, employers, and guarantors may be contacted and verified. Finally, I agree that all of the information I've provided is true and accurate (if it's not you may not get a place)."
                               component={CheckBoxField}/>
                    </Col>
                </Row>
            </form>
        );
    }
}

const validate = values => {
    const errors = {};

    !values.bio && (errors.bio = "Required");
    !values.polyrents_tos && (errors.polyrents_tos = " ");

    (values.bio && values.bio.length > 700) && (errors.bio = "Must be 700 characters or fewer");

    return errors;
};

const submit = (data, dispatch) => {
    return dispatch(handleSubmitBio(data));
};

BioForm = reduxForm({
    form: 'application_bio',
    onSubmit: submit,
    validate
})(BioForm);

const mapStateToProps = (state) => ({
    first_name: state.activeUser.first_name,
    is_bio_complete: state.tenant.application.is_bio_complete,
    initialValues: {
        bio: state.tenant.application.bio,
    }
});

export default connect(mapStateToProps)(BioForm);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/BioForm.js